var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6611 2.80993C15.5783 2.91637 16.25 3.70709 16.25 4.63042V17.5413L10 14.4163L3.75 17.5413V4.63042C3.75 3.70709 4.42173 2.91637 5.3389 2.80993C6.86797 2.63248 8.42333 2.54126 10 2.54126C11.5767 2.54126 13.132 2.63248 14.6611 2.80993Z",
    stroke: "#868889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.ddf01931d422f6f6a9fe897e1b2c91c0.svg";
export { ForwardRef as ReactComponent };